import api from '../_api';

export default {

    getCostTypes: () => api.getCostTypes()
        .then(response => response)
        .catch(error => error),

    getCostNominalCodes: () => api.getCostNominalCodes()
        .then(response => response)
        .catch(error => error),

    getCostStatuses: () => api.getCostStatuses()
        .then(response => response)
        .catch(error => error),

    getSecondaryCostStatuses: () => api.getSecondaryCostStatuses()
        .then(response => response)
        .catch(error => error),

    /* eslint-disable-next-line */
    getResourceTypes({ commit }, { supplierId }) {
        return api.getResourceTypes(supplierId)
            .then(response => response)
            .catch(error => error);
    },

    getIndustryTypes: () => api.getIndustryTypes()
        .then(response => response)
        .catch(error => error),

    getTransactionTypes: () => api.getTransactionTypes()
        .then(response => response)
        .catch(error => error),

    getTeams: () => api.getTeams()
        .then(response => response)
        .catch(error => error),

    getUserTeam: () => api.getUserTeam()
        .then(response => response)
        .catch(error => error),

    getAccountTypes: () => api.getAccountTypes()
        .then(response => response)
        .catch(error => error),

    getSources: () => api.getSources()
        .then(response => response)
        .catch(error => error),

    getMediums: () => api.getMediums()
        .then(response => response)
        .catch(error => error),

    getUsers: () => api.getUsers()
        .then(response => response)
        .catch(error => error),

    getEventStatuses: () => api.getEventStatuses()
        .then(response => response)
        .catch(error => error),

    getTags: () => api.getTags()
        .then(response => response)
        .catch(error => error),

    getTaxRates: () => api.getTaxRates()
        .then(response => response)
        .catch(error => error),

};
